import React, { KeyboardEvent, useCallback, useState } from "react";
import { HandleInputChangeRequest, ValueTypes } from "../../types";
import { ValueColumn, StyledInput, StyledCheckbox } from "./styles";
import { AriType } from "../../../updateForm";

interface Props {
  ticker: string;
  isDisabled: boolean;
  valueType: ValueTypes;
  type: AriType;
  defaultValue: number | boolean | string;
  inputType: "text" | "checkbox";
  enableEdition: boolean;
  date: Date;
  handleInputChange: (props: HandleInputChangeRequest) => void;
  isZero?: boolean;
  red?: boolean;
  bold?: boolean;
  inputWidth: number;
}

export const Input = (
  {
    ticker,
    isDisabled,
    valueType,
    type,
    defaultValue,
    inputType,
    enableEdition,
    date,
    handleInputChange,
    isZero,
    red,
    bold,
    inputWidth,
  }: Props
) => {
  const [oldValue, setOldValue] = useState<number | boolean | string>(defaultValue);
  const [checked, setChecked] = useState<boolean>(!!defaultValue);

  const handleOnBlur = useCallback((value: string): void => {
    const floatValue = parseFloat(value);
    if (floatValue === oldValue) {
      return;
    }

    setOldValue(floatValue);
    handleInputChange({ ticker, valueType, date, value: floatValue, type });
  }, [oldValue, ticker, valueType, date, handleInputChange, type]);

  const handleOnKeyEnterPress = useCallback((event: KeyboardEvent, value: string): void => {
    if (event?.key === "Enter" || event?.key === "NumpadEnter") {
      event.preventDefault();
      event.stopPropagation();

      const floatValue = parseFloat(value);
      if (floatValue === oldValue) {
        return;
      }

      setOldValue(floatValue);
      handleInputChange({ ticker, valueType, date, value: floatValue, type });
    }
  }, [oldValue, ticker, valueType, date, handleInputChange, type]);

  const onCheckboxChange = useCallback(() => {
    setChecked(!checked);
    handleInputChange({ ticker, valueType, date, value: !checked, type });
  }, [ticker, valueType, date, checked, handleInputChange, type]);

  return (
    <ValueColumn disabled={isDisabled} red={red} width={inputWidth}>
      {inputType === "text" &&
        <StyledInput
          type={inputType}
          defaultValue={defaultValue as number}
          readOnly={isDisabled || !enableEdition}
          isZero={isZero}
          bold={bold}
          onBlur={(event) => handleOnBlur(event?.target?.value)}
          onKeyUp={(event) => handleOnKeyEnterPress(event, event?.currentTarget?.value)}
        />
      }
      {inputType === "checkbox" &&
        <StyledCheckbox
          type={inputType}
          checked={checked}
          disabled={isDisabled || !enableEdition}
          onChange={onCheckboxChange}
        />
      }
    </ValueColumn>
  )
};
